'use strict';

var base = require('./base');
var resourceArticles = require('../components/resourceArticles');
var scrollAnimate = require('base/components/scrollAnimate');
const { extendInit } = require('../../../../../../../vendor/extend/cartridges/int_extend_sfra/cartridge/client/default/js/product/detail');
var Extend = window.Extend || undefined;
var extendInitRunCount = 0;
var extendInitRunFlag = false;
function toMinorUnits(number) {
    return parseInt(Math.ceil(number * 100), 10).toFixed(0);
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
//  console.log('Detail.js document ready.');
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
    //$('.compare-btn').toggleClass('disabled', enableOrDisable);
}

/**
 * Set the initial state of the tabs on page load
 */
function setTabState() {
    var theTab;
    var pageParams = new URLSearchParams(window.location.search);
    var tabMappings = {
        compatibility: 'compatibility-tab',
        ataglance: 'atAGlance-tab',
        whatsinthebox: 'marketingPackageContent-tab',
        techspecs: 'technicalSpecs-tab',
        support: 'supportTab-tab',
        awards: 'reviewsAndWards-tab'
    };
    $('.product-tabs__item').first().find('.product-tabs__link').addClass('active');
    $('.product-tabs__pane').first().addClass('active');
    $('.product-tabs__pane').first().find('.product__collapse-btn').removeClass('collapsed');
    $('.product-tabs__pane').first().find('.product-tabs__pane-collapse').removeClass('collapsed').addClass('show');
    if (pageParams && pageParams.has('tab')) {
        theTab = pageParams.get('tab');
        if (tabMappings[theTab]) {
            // adding delay to allow dynamic page content to load
            window.setTimeout(function () {
                $('#' + tabMappings[theTab]).trigger('click');
                $('html, body').animate({
                    scrollTop: $('#product-tabs').offset().top - $('header').height()
                }, 0);
            }, 600);
        }
    }
}

/**
 * BV Review submit triggers Yotpo API call to submit points.
 */
function bvLoyaltyAction() {
    // BV review submission
    $('body').on('click', '.bv-submission-button-submit.bv-form-actions-submit', function () {
        var urlTarget = $('.product-detail').data('loyalty-target');
        var email = $('.product-detail').data('loyalty-email');

        // Check for loyalty pid and email. If empty, stop function
        if (urlTarget !== '' && urlTarget !== null && email !== '' && email !== null) {

            // Loyalty vars exist. Check for BV errors in form
            if ($('.bv-error').length === 0) {
                var data = {
                    email: email,
                    action: 'Write a Review'
                };

                // AJAX call to custom action api to award points.
                $.ajax({
                    url: urlTarget,
                    method: 'POST',
                    data: data
                });
            }
        }
    });
}

/**
 * Create click/scroll event for BV Reviews
 */
function bvInlineReviewsClick() {
    $('.data-bv-show').on('click', '.ratings-summary', function () {
        scrollAnimate($('.bv-reviews'));
        if (!$('.product__collapse').hasClass('show')) {
            $('.bv-reviews .product__collapse-btn').trigger('click');
        }
    });

    $(document).on('click', '#bv_components_histogram .bv_button_buttonFull', function () {
        scrollAnimate($('.bv-reviews'));
        if (!$('.product__collapse').hasClass('show')) {
            $('.bv-reviews .product__collapse-btn').trigger('click');
        }
    });
}

/**
 * Trigger click for BV Questions and Answers tab
 */
function bvQATabsClick() {
    $(document).on('click', '[data-content-type="question"]', function (e) {
        e.preventDefault();
        scrollAnimate($('.bv-questions'));
        if (!$('.bv-questions .product__collapse').hasClass('show')) {
            $('#bvQuestions-collapse-btn').trigger('click');
        }
    });
}

/**
 * Check location for review action query, if present trigger modal
 */
function checkIncomingReviewLink() {
    let loc = window.location.href;
    if (loc.indexOf('writeReview') !== -1) {
        scrollAnimate($('.bv-reviews'));
        $('#first-to-write').trigger('click');
    }
}
/**
 * Fix  legacy image paths
 */
function updateLegacyOverviewImages() {
    $('.legacy-overview-section').find('img').each(function () {
        var $img = $(this);
        var oldSrc = $img.attr('src');
        var newSrc;
        if (oldSrc.indexOf('/resources') === 0) {
            newSrc = "https://s3.belkin.com" + oldSrc;
            $img.attr('src', newSrc);
        }
    });
}
/**
 * Fix  overview matrix  custom html image paths
 */
function updateOverviewMatrixImages() {
    $('.overview-matrix').find('img, source').each(function () {
        var $img = $(this);
        var oldSrc = $img.attr('src');
        var newSrc;
        if (oldSrc.indexOf('/resources') === 0) {
            newSrc = 'https://s3.belkin.com' + oldSrc;
        } else if (oldSrc.indexOf('https://www.belkin.com/resources/') === 0) {
            newSrc = oldSrc.replace('https://www.belkin.com/resources/','https://s3.belkin.com/resources/');
        }
        $img.attr('src', newSrc);
    });
}
/**
 * show articles on page load and on tab click etc.
 */
function renderPdpSupportArticles() {
    var url = $('.js-pdp-support').data('href');
    $('div.article-content').empty();
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $('div.article-content').append(data.renderedTemplate);
            }
        }
    });
}

/**
 * Update support articles on variant change;
 * @param {string} pid - the variant sku to which we have changed
 */
function updateSupportArticleUrl(pid) {
    // console.log('running updateSupportArticleUrl(' + pid + ')');
    var $supportTabHeader = $('.js-pdp-support');
    var currentArticleUrl = $supportTabHeader.data('href');
    var newArticleUrl = currentArticleUrl.replace(/pid=[-0-9a-zA-Z]+/, 'pid=' + pid);
    $supportTabHeader.attr('data-href', newArticleUrl);
}

/**
 * Fire a global event as a hook for other code to respond to pdp initialization
 */
function fireGlobalPdpInitEvent() {
    // console.log('running fireGlobalPdpInitEvent in detail.js');
    $('body').trigger('product:pdpInit');
}

/**
 * Fire events specifically for sticky nav add to cart and buy now buttons
 */
function initStickyNavCtaTracking() {
    $('body').on('click', '.sticky-pdp-header .add-to-cart', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'sticky-nav-add-to-cart',
            pdpSku: window.pdpSku
        });
    });
    $('body').on('click', '.sticky-pdp-header .add-buy-now', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'sticky-nav-buy-now',
            pdpSku: window.pdpSku
        });
    });
}

/**
 * Initialize the read more/read less functionality for marketingShortDescription.
 */
function initMarketingShortDescription() {
    // console.log('running the global function initMarketingShortDescription...');
    $('.cutoff-control').remove();
    var $descElement = $('.marketing-short-description');
    var readMoreText = $descElement.attr('data-read-more');
    var readLessText = $descElement.attr('data-read-less');
    var cutoffLength = $descElement.attr('data-cutoff-length');
    var $cutoffControl = $('<div class="cutoff-control"></div');
    var $wrapper = $('.marketing-short-description-wrapper');
    $cutoffControl.appendTo($wrapper);
    $wrapper.removeClass('lengthy-description');
    if (readMoreText && readLessText && cutoffLength && $descElement.html().length > cutoffLength) {
        $descElement.data('fullText', $descElement.html());
        $descElement.data('shortText', $descElement.data('fullText').substring(0, cutoffLength) + '...');
        $descElement.html($descElement.data('shortText'));
        $cutoffControl.text(readMoreText);
        $cutoffControl.data('action', 'readMore');
        $cutoffControl.off('click');
        $cutoffControl.on('click', function () {
            if ($cutoffControl.data('action') === 'readLess') {
                $descElement.html($descElement.data('shortText'));
                $cutoffControl.text(readMoreText);
                $cutoffControl.data('action', 'readMore');
                $cutoffControl.removeClass('action-read-less');
            } else {
                $descElement.html($descElement.data('fullText'));
                $cutoffControl.text(readLessText);
                $cutoffControl.data('action', 'readLess');
                $cutoffControl.addClass('action-read-less');
            }
        });
        $wrapper.addClass('lengthy-description');
    }
    if ($descElement.text().trim().length > 0) {
        $wrapper.addClass('show-description');
    }
}

/**
 * Show sub-gallory content (e.g. "why buy direct" stuff) only when the product is orderable
 */
function initSubGalleryContent() {
    $('.sub-gallery-content-wrapper').addClass('show-sub-gallery-content');
}

/**
 * Initialize or re-initialize the Extend offer on the PDP
 */
function initExtendOffer() {
    var pdpOffer;
    var pid;
    var price;
    var category;
    var ctaType;
    if (EXT_GLOBAL_SWITCH) {
        extendInitRunCount += 1;
        if (!extendInitRunFlag && typeof Extend !== 'undefined' && $('#pdp-extend-offer').length) {
            pdpOffer = $('#pdp-extend-offer');
            pid = pdpOffer.data('extend-id');
            price = Number(toMinorUnits(pdpOffer.data('extend-price')));
            category = pdpOffer.data('extend-category').toString();
            ctaType = $('#pdp-extend-offer').data('cta-type');
            if (typeof Extend !== 'undefined' && $('#pdp-extend-offer').data('cta-type') === 'purchase') {
                Extend.buttons.render('#pdp-extend-offer', {
                    referenceId: pid,
                    price: price,
                    category: category
                });
            }
            $('body').on('product:afterAddToCart', function (e, data) {
                var plan;
                var product;
                var component = Extend.buttons.instance('#pdp-extend-offer');
                if (component) {
                    plan = component.getPlanSelection();
                    product = component.getActiveProduct();
                }
            });
            extendInitRunFlag = true;
        }
    }
}

/** Hide or show the shipping and warranty widgets based on product orderability
 * @param {Object} product - the product returned from the Product-Variation JSON response. On initial page load this will be undefined, so we'll assign an empty object to it to prevent exception on asking for its hide(Shipping|Warranty)Widget value.
 */
function initPdpWidgets(product) {
    // console.log('running initPdpWidgets. product = ' + JSON.stringify(product));
    var theProduct = product || {};
    var ctaType = $('.product-control__col').attr('data-cta-type');
    if (widgetConfig && widgetConfig.hideShippingWidgetNonOrderable) {
        if ((ctaType === 'purchase' || ctaType === 'preorder') && widgetConfig && widgetConfig.shippingWidgetEnabled && !theProduct.hideShippingWidget) {
            $('.pdp-shipping-widget-wrapper').addClass('show-widget');
            $('.pdp-warranty-widget-wrapper').addClass('shipping-widget-visible'); // to show a top border only if shipping widget is not there.
        }
    } else if (widgetConfig && widgetConfig.shippingWidgetEnabled && !theProduct.hideShippingWidget) {
        $('.pdp-shipping-widget-wrapper').addClass('show-widget');
        $('.pdp-warranty-widget-wrapper').addClass('shipping-widget-visible');
    }
    if (widgetConfig && widgetConfig.warrantyWidgetEnabled && !theProduct.hideWarrantyWidget) {
        $('.pdp-warranty-widget-wrapper').addClass('show-widget');
    }
}
/** Hide or show the Channel Advisors WTB CTA
 * @param {Object} product - the product returned from the Product-Variation JSON response. On initial page load this will be undefined, so we'll assign an empty object to it to prevent exception on asking for its hide(Shipping|Warranty)Widget value.
 */
function checkChannelAdvisorWTB(product) {
    var theProduct = product || {};
    // console.log('productChannelAdvisorWTB', theProduct.id, theProduct.productChannelAdvisorWTB);
    $('#js-channel-advisor-iframe').data('product', theProduct.id); // setter
    if (theProduct.productChannelAdvisorWTB) {
        $('.js-channel-advisor').removeClass('d-none');
        $(document).on('click', '.js-channel-advisor-btn', function () {
            $('#channelAdvisorModal').modal('show');
            document.getElementById('js-channel-advisor-iframe').src = 'https://where-to-buy.co/widgets/core/shoppable/index.html?pid=12047213&model=' + theProduct.id;
        });
    } else {
        $('.js-channel-advisor').addClass('d-none');
        $(document).off('click', '.js-channel-advisor-btn');
    }
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },
    init: function () {
        setTabState();
        bvInlineReviewsClick();
        bvQATabsClick();
        bvLoyaltyAction();
        bvQATabsClick();
        checkIncomingReviewLink();
        base.initOverviewGalleries();
        base.groupOverviewTopics();
        updateLegacyOverviewImages();
        updateOverviewMatrixImages();
        renderPdpSupportArticles();
        fireGlobalPdpInitEvent();
        initMarketingShortDescription();
        initSubGalleryContent();
        initPdpWidgets();
        initExtendOffer();
        initStickyNavCtaTracking();
    },
    availability: base.availability,
    // addToCart: base.addToCart,
    images: base.images,
    resourceArticles: resourceArticles.pdp,
    initExtendOffer: initExtendOffer,
    updateAttributesAndDetails: function () {
        // console.log('executing updateAttributesAndDetails in app_belkin detail.js...');
        $('body').on('product:statusUpdate', function (e, data) {
            // console.log('product:statusUpdate event fired...');
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
            if (data.renderedPrice) {
                // console.log('there is data.renderedPrice.');
                $('.price-wrap').empty().html(data.renderedPrice);
            }
            if (data.productName && data.productName.trim().length > 0) {
                $('.product-name-block').find('.product-name').html(data.productName);
            }
            if (data.familyName && data.familyName.trim().length > 0) {
                $('.product-family-name-block').find('.product-family-name').html(data.familyName);
            }
            if (data.webProductSubName && data.webProductSubName.trim().length > 0) {
                $('.product-name-block').find('.product-sub-name').html(data.webProductSubName);
            }
            if (data.webProductSubName !== data.webProductName) {
                if (data.webProductName && data.webProductName.trim().length > 0) {
                    $('.product-name-block').find('.web-product-name').html(data.webProductName);
                }
            } else {
                $('.product-name-block').find('.web-product-name').html('');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);
            // BCC-2262 do not insert stock message if in stock
            $('.availability-msg', response.$productContainer).empty();
            if (response.product && response.product.availability && response.product.availability.status && response.product.availability.status !== 'IN_STOCK') {
                $('.availability-msg', response.$productContainer).html(response.message);
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);
                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
            if (response.product.multiAttribute && response.product.id === response.product.masterId) {
                // removing 2024.1.16 per Hauwen
                // $('.product-control-wrapper').empty().html('<div class="alert alert-warning" role="alert"><span class="message">' + $('.product-control').data('tryother') + '</span></div>');
                $('.product-control-wrapper').empty();
            } else if (response.product.renderedCta && response.product.renderedCta.trim().length > 0) {
                $('.product-control-wrapper').empty().html(response.product.renderedCta);
                checkChannelAdvisorWTB(response.product);
                initSubGalleryContent();
                initPdpWidgets(response.product);
            }
            if (response.product.longDescription && response.product.longDescription.trim().length > 0) {
                if ($('.legacy-overview-column').length === 1) {
                    $('.legacy-overview-column').empty().html(response.product.longDescription);
                    updateLegacyOverviewImages();
                }
            }
            if (response.product.renderedOverviewMatrix && response.product.renderedOverviewMatrix.trim().length > 0) {
                if ($('.matrix-overview').length === 1) {
                    $('.matrix-overview').empty().html(response.product.renderedOverviewMatrix);
                    base.initOverviewGalleries();
                    base.groupOverviewTopics();
                    updateOverviewMatrixImages();
                }
            }
            if (response.product.marketingShortDescription && response.product.marketingShortDescription.trim().length > 0) {
                if ($('.marketing-short-description').length > 0) {
                    $('.marketing-short-description').empty().html(response.product.marketingShortDescription);
                    initMarketingShortDescription();
                }
            }
            if (response.product.compatibleDevices) {
                var devicesHtml = '';
                var devicesCollection;
                var devicesList;
                var belkinAttrs;
                if (response && response.product && response.product.attributes) {
                    belkinAttrs = response.product.attributes.find(function (attributeGroup) {
                        return attributeGroup.ID === 'BelkinOnlyCustomAttributes';
                    });
                }
                if (belkinAttrs && belkinAttrs.attributes) {
                    devicesCollection = belkinAttrs.attributes.find(function (attribute) {
                        return attribute.label === 'Compatible Devices';
                    });
                    if (devicesCollection && devicesCollection.value && Array.isArray(devicesCollection.value)) {
                        devicesList = devicesCollection.value;
                    }
                }
                if (devicesList && devicesList.length > 0) {
                    devicesList.forEach(function (device) {
                        devicesHtml += '<li>' + device + '</li>';
                    });
                    if (devicesHtml.trim().length > 0) {
                        $('ul.compatible-devices-list').empty().html(devicesHtml);
                    }
                }
            }
            if (response.product.compatibilityStatement && response.product.compatibilityStatement.trim().length > 0) {
                $('.compatibility-statement').empty().html(response.product.compatibilityStatement);
            }
            if (response.product && response.product.id) {
                updateSupportArticleUrl(response.product.id);
            }
            if (response.product.renderedTechSpecs && response.product.renderedTechSpecs.trim().length > 2) {
                $('.tech-specs-wrapper').empty().html(response.product.renderedTechSpecs);
            }
            // If notify me update the product id
            if ($('.back-in-stock-container').length) {
                var currProdID = response.product.id;
                var currCountry = $('.gtm-page-data').data('page-country');
                if (currProdID.indexOf("SKU") >= 0) {
                    var updateProdID = currProdID.replace("SKU", "");
                    $("input[name='Product']").attr('value', updateProdID);
                } else {
                    $("input[name='Product']").attr('value', currProdID);
                }
                // $('input[name="Country"]').attr('value', country);
                $('input[name="Source"]').attr('value', "notifyme-" + currProdID);
                $("input[name='Country'], input[name='Country Site']").attr('value', currCountry);
            }
            if (typeof Extend !== 'undefined' && $('#pdp-extend-offer').length && response.product && Extend.buttons.instance('#pdp-extend-offer')) {
                if (response.product.cta.type === 'purchase') {
                    Extend.buttons.instance('#pdp-extend-offer').setActiveProduct(response.product.id);
                } else {
                    Extend.buttons.instance('#pdp-extend-offer').setActiveProduct(null);
                }
            }
            // Fire gallery event for monetate
            if (response.product && response.product.id) {
                window.monetateQ = window.monetateQ || [];
                window.monetateQ.push([
                    'addProductDetails', [{
                        productId: response.product.id,
                        sku: response.product.id
                    }]
                ]);
                window.monetateQ.push(['trackData', { nonPageView: true }]);
            }
            if (response.product && response.product.packageContentsHtml && response.product.packageContentsHtml.trim().length > 0) {
                $('#marketingPackageContent-collapse').find('.collapse-pane').empty().html(response.product.packageContentsHtml);
            }
            if (response.product && response.product.atAGlanceHtml && response.product.atAGlanceHtml.trim().length > 0) {
                $('#atAGlance-collapse').find('.collapse-pane').empty().html(response.product.atAGlanceHtml);
            }
            if (response.product && response.product.productDisclaimers && response.product.productDisclaimers.trim().length > 0) {
                $('#disclaimers-collapse').find('.collapse-pane').empty().html(response.product.productDisclaimers);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    showRelatedArticles: function () {
        // $('.js-pdp-support').on('click', function (e) {
        //     e.preventDefault();
        //     renderPdpSupportArticles();
        // });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    backInStockEmailSend: function () {

        $('body').on('submit', '#back-in-stock-form', function (e) {
            e.preventDefault();

            var form = $(this);
            var url = form.attr('action');
            form.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.invalid-feedback').text('');
                        $('.js-back-in-stock-form').hide();
                        $('.js-back-in-stock-success').fadeIn();
                        setTimeout(function () {
                            $('#backInStockModal').modal('hide');
                            $('.js-back-in-stock-form').fadeIn();
                            $('.js-back-in-stock-success').hide();
                            $('.js-back-in-stock-email').val('');
                        }, 2500);
                    }
                },
                error: function () {
                    var genericError = $('.js-back-in-stock-email').data('genericerror');
                    $('.invalid-feedback').text(genericError).show();
                    $('.js-back-in-stock-email').addClass('is-invalid');
                    form.spinner().stop();
                }
            });
        });
    }
};
